define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CustomerServerGroupModel = /** @class */ (function () {
        function CustomerServerGroupModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.CustomerName = ko.observable();
            this.ServerGroupId = ko.observable();
            this.Domain = ko.observable();
            this.ServerGroupName = ko.observable();
            this.ServerId = ko.observable();
            this.OldServerId = ko.observable();
            this.Dns = ko.observable('');
            this.OldDns = ko.observable('');
            this.DnsDomain = ko.observable('');
            this.DnsName = ko.observable('');
            this.OldDnsName = ko.observable('');
            this.IpAddress = ko.observable('');
            this.UserPassword = ko.observable('');
            this.UpdateDns = ko.observable(false);
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerServerGroupModel.Mapping, self);
            }
        }
        CustomerServerGroupModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerServerGroupModel(options.data);
            }
        };
        return CustomerServerGroupModel;
    }());
    return CustomerServerGroupModel;
});
//# sourceMappingURL=CustomerServerGroupModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerServerGroupModel.js
// module id = 69
// module chunks = 2